export const imagenes = require.context("../assets/imgs/", true);
